/**
 * feature/dashboard — spec §F7 (Dashboard).
 * PLACEHOLDER: this feature ships in milestone M5 (§K). M1 Task 7 creates the folder per
 * the §B5 tree and a component that renders the milestone marker, so every route in §F1
 * resolves and the topbar nav is exercised end to end from M1. Strings go through
 * `t()` per §F12 (keys under `placeholder.`).
 */
import { useTranslation } from 'react-i18next';

import { Placeholder } from '../../components/Placeholder';

export function DashboardPage() {
  const { t } = useTranslation();
  return (
    <Placeholder
      title={t('placeholder.dashboard')}
      body={t('placeholder.dashboardBody')}
      milestone="M5"
    />
  );
}

export default DashboardPage;
